import { BaseBlockProps } from '../../defs/block';

export type RainbowSoapBlockID = 'rainbowSoap';

export type RainbowSoapBlockType = 'rainbowSoap';

export type RainbowSoapBlockProps = {
  type: RainbowSoapBlockType;
} & BaseBlockProps;

export const rainbowSoapBlockProps: Record<
  RainbowSoapBlockID,
  RainbowSoapBlockProps
> = {
  rainbowSoap: {
    id: 'rbs',
    type: 'rainbowSoap',
    immobile: true,
  },
};
